import { captureException } from '@sentry/core';

export const confluenceFlags: Record<string, string> = {};

const FeatureFlagQuery = `query {
  featureFlags {
    edges {
      node {
        id
        value
      }
    }
  }
}`;

export const loadConfluenceFlags = async () => {
  try {
    const json = await (
      await fetch('/cgraphql', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([
          {
            query: FeatureFlagQuery,
            variables: {},
          },
        ]),
      })
    ).json();

    if ('errors' in json[0] && json[0].errors.length > 0) {
      for (const error of json[0].errors) {
        captureException(new Error(error));
      }
    }

    for (const edge of json[0].data.featureFlags.edges) {
      confluenceFlags[edge.node.id] = edge.node.value;
    }
  } catch (error: any) {
    captureException(error);
  }
};
